<template>
  <sweet-modal ref="add_attribute_modal">
    <mail-builders-module-attribute
      :attribute_type="attribute_type"
      :active_locales="template_type.active_locales"
      :with_prefix="false"
      :readonly_key="false"
    ></mail-builders-module-attribute>
    <div class="d-flex">
      <button class="btn btn-primary btn-lg ml-auto mt-4" @click="add_attribute()">{{ 'add' | t }}</button>
    </div>
  </sweet-modal>
</template>
<script>
// @ts-check

export default {
  props: {
    template_type: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      attribute_type: {
        key: null,
        value: null,
        description: null,
        required: null,
        visible: null,
        input_type: null,
        avaliable_liquids: [],
        locale_types: []
      }
    };
  },
  methods: {
    open_modal() {
      this.$refs.add_attribute_modal.open();
    },
    /*
     * Emit a copy (to remove reactivity) of new attribute_type object as input event.
     * Resets object so next time modal is open, input fields is fresh
     */
    add_attribute() {
      this.$emit('input', JSON.parse(JSON.stringify(this.attribute_type)));

      Object.keys(this.attribute_type).forEach((key) => {
        if (Array.isArray(this.attribute_type[key])) {
          this.attribute_type[key] = [];
          return;
        }

        this.attribute_type[key] = null;
      });

      this.$refs.add_attribute_modal.close();
    }
  }
};
</script>
